// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"06df0492","496":"eb4e17b4","498":"f2f39d32","703":"b28ae25c"}[chunkId] + ".chunk.js";
};